'use strict';

import { Collapse } from 'bootstrap';

export default class OPLResponsiveAccordionPanel {
    constructor() {
        this.collapses = document.querySelectorAll('[data-opl-responsive-accordion-panel-collapse]');
        this.lgQuery = window.matchMedia(`(min-width: ${window.getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg')})`);
    }

    init() {
        this.initSidebarAccordions();
    }

    initSidebarAccordions() {
        const self = this;

        if (self.collapses) {
            self.collapses.forEach(collapse => {
                const bsCollapse = Collapse.getOrCreateInstance(collapse);

                // The sidebar "accordion" should be expanded on desktop view
                if (bsCollapse) {
                    self.lgQuery.addEventListener('change', () => {
                        if (self.lgQuery.matches) {
                            bsCollapse.show();
                        } else {
                            bsCollapse.hide();
                        }
                    });
                }
            });
        }
    }
}
